import React, { Component } from 'react';

//Compponent
import VerifyTemplate from '../../templates/Verify';
import { strings } from '../SignUp/SignUpContent';

class Verify extends Component {
    componentWillMount() {
        // Reads the language from the store
        strings.setLanguage(this.props.language);
    }
	render() {
		return (
			<VerifyTemplate data={strings}/>
		)
	}
}

export default Verify;


// WEBPACK FOOTER //
// ./src/redux/components/pages/Verify/Verify.jsx